import React, { useRef, useEffect } from "react";
import Popup from "./PopUp";
import "reactjs-popup/dist/index.css";
import ButtonGroup from "./ButtonGroup";
import MapPopup from "./MapPopup";
import MerseySidePort from "./content/main/MerseySidePort.png";
import TouristRoute from "./content/routes/Tourist.png";
import FerryPassengerRoute from "./content/routes/FerryPassenger.png";
import FreightRoute from "./content/routes/Freight.png";
import PinData from "./data/Pins.json";
import TouristData from "./data/Tourist.json";
import PassengerData from "./data/Passenger.json";
import FreightData from "./data/Freight.json";
import MapButtons from "./MapButtons";
import MapImages from "./MapImages";
import MapPins from "./MapPins";
import "boxicons";

class Map extends React.Component /* = ({ mapPageCallback }) => */ {
  _isMounted = false;
  popupRef = React.createRef();
  pageYOffset = React.createRef(window.pageYOffset);
  routes = [
    { src: TouristRoute, xPosition: "42%", yPosition: "40%", size: "16%" },
    { src: FerryPassengerRoute, xPosition: "38%", yPosition: "38%", size: "33%" },
    { src: FreightRoute, xPosition: "20%", yPosition: "10.5%", size: "53.1%" },
  ];
  constructor(props) {
    super(props);

    var newScrollToFirstCardHighlight;
    var newHighlightId;
    var newScope;

    window.addEventListener("scroll", (event) => {
      if (this.popupRef.current) {
        const scrollAmount = this.pageYOffset.current - window.pageYOffset;
        if (scrollAmount !== 0) {
          const left = parseInt(this.popupRef.current.style.left);
          const top = parseInt(this.popupRef.current.style.top) + scrollAmount;
          this.movePopup(left, top);
          this.pageYOffset.current = window.pageYOffset;
        }
      }
    });

    Object.entries(this.props).map(([key, value]) => {
      if (key === "data" && key) {
        return (newScope = value);
      } else if (key === "highlightId" && key) {
        return (newHighlightId = value);
      } else if (key === "scrollToFirstCardHighlight") {
        return (newScrollToFirstCardHighlight = value);
      } else {
        return null;
      }
    });

    var newButtonHighlightIndex = newScope["journeyCategory"].replace(/^\D+/g, "") - 1;

    var newIsMobile = window.innerWidth <= 768;
    this.state = {
      x: 0,
      y: 0,
      animationTimer: null,
      mapPopupTitle: "",
      mapPopupDescription: "",
      mapPopupBullets: undefined,
      mapPopupSrc: undefined,
      showUseCaseCard: false,
      showUseCaseDetail: false,
      selectedPage: "",
      selectedCard: "",
      selectedScope: newScope,
      selectedPinData: PinData.themes[0],
      pinHighlightIndex: PinData.themes[0].theme,
      imageHighlightName: "",
      floatingLabels: false,
      highlightId: newHighlightId,
      buttonHighlightIndex: newButtonHighlightIndex,
      isMobile: newIsMobile,
      scrollToDetail: false,
      scrollToFirstCardHighlight: newScrollToFirstCardHighlight,
      firstCardHighlightRef: document.getElementById("FirstCard"),
    };
  }

  componentDidMount() {
    this._isMounted = true;
    window.addEventListener("resize", this.resize.bind(this));
    this.openPopup({ clientX: 0, clientY: 0 }, this.state.selectedPinData.pins[0]);
    this.closePopup();
    this.resize();
  }

  resize() {
    if (this._isMounted) {
      const isMob = window.innerWidth <= 768;
      this.setState({ isMobile: isMob });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener("resize", this.resize.bind(this));
  }

  componentDidUpdate() {
    if (this.state.scrollToDetail) {
      const element = document.getElementById("Ref");
      element.scrollIntoView({ behaviour: "smooth" });

      this.setState({
        scrollToDetail: false,
      });
    } else if (this.state.scrollToFirstCardHighlight) {
      if (!this.state.isMobile) {
        const element = document.getElementById("FirstCard");
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }

      this.setState({
        scrollToFirstCardHighlight: false,
      });
    }
  }

  handlePageChange = (event) => {
    var name = event.currentTarget.id;
    this.props.mapPageCallback({ name });
  };

  swapScopeFeatures = (event) => {
    this.setState({ highlightId: "" });

    if (event.currentTarget.name === "Tourist") {
      this.setState({
        selectedScope: TouristData,
        buttonHighlightIndex: 0,
      });
    } else if (event.currentTarget.name === "Passenger") {
      this.setState({
        selectedScope: PassengerData,
        buttonHighlightIndex: 1,
      });
    } else if (event.currentTarget.name === "Freight") {
      this.setState({
        selectedScope: FreightData,
        buttonHighlightIndex: 2,
      });
    }
  };

  swapPins = (event) => {
    if (event.target.name === "Digitalisation & Technology") {
      this.setState({
        selectedPinData: PinData.themes[0],
        pinHighlightIndex: event.target.name,
      });
    } else if (event.target.name === "Green Transition to Net Zero") {
      this.setState({
        selectedPinData: PinData.themes[1],
        pinHighlightIndex: event.target.name,
      });
    } else if (event.target.name === "Regeneration & Skills") {
      this.setState({
        selectedPinData: PinData.themes[2],
        pinHighlightIndex: event.target.name,
      });
    }
  };

  swapImageHighlightName = (event) => {
    this.setState({
      imageHighlightName: event.currentTarget.name,
    });
  };

  swapImageUnhighlightName = (event) => {
    this.setState({
      imageHighlightName: null,
    });
  };

  checkForWidth = async (nextFunction) => {
    if (this.popupRef === undefined)
      setTimeout(() => {
        this.checkForWidth(nextFunction);
      }, 5);
    else {
      if (this.popupRef.current.clientWidth === 0) {
        setTimeout(() => {
          this.checkForWidth(nextFunction);
        }, 5);
      } else nextFunction();
    }
  };
  movePopup = async (left, top) => {
    this.checkForWidth(() => {
      const width = this.popupRef.current.clientWidth / 2;
      const height = this.popupRef.current.clientHeight + 50;
      this.popupRef.current.style.left = `${Math.min(Math.max(left, width), window.innerWidth - width)}px`;
      this.popupRef.current.style.top = `${Math.max(top, height)}px`;
    });
  };

  openPopup = (event, image) => {
    this.setState({
      mapPopupTitle: image.title,
      mapPopupDescription: image.text,
      mapPopupSrc:
        image.name !== undefined && this.state.selectedScope["journeyCategory"] !== undefined
          ? `${this.state.selectedScope["journeyCategory"].toLowerCase()}/modular-map-icons/${image.name}`
          : undefined,
      mapPopupBullets: image.bullets,
    });
    this.popupRef.current.style.animation = "none";
    this.popupRef.current.style.display = "flex";
    this.popupRef.current.style.animation = "slideup 0.5s";
    this.movePopup(event.clientX, event.clientY);
  };

  closePopup = () => {
    clearTimeout(this.state.animationTimer);
    this.popupRef.current.style.animation = "slidedown 0.5s";
    this.setState({
      animationTimer: setTimeout(() => {
        this.popupRef.current.style.display = "none";
      }, 500),
    });
  };

  handleMapClick = (event, image) => {
    clearTimeout(this.state.animationTimer);
    if (this.popupRef.current.style.display === "flex") {
      this.closePopup();
      setTimeout(() => {
        this.openPopup(event, image);
      }, 500);
    } else {
      this.openPopup(event, image);
    }
  };

  scrollToTop = () => {
    const element = document.getElementById("Ref");
    element.scrollIntoView({ behaviour: "smooth" });
  };

  render() {
    return (
      <div>
        <div id="Ref" name="usecasetitle"></div>
        {!this.state.showUseCaseDetail ? (
          <div>
            <div
              style={{
                display: "flex",
                flex: 1,
                width: "100%",
                height: "100px",
                left: "0px",
                backgroundColor: "white",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <div style={{ display: "flex", flex: 1, width: "80%", justifySelf: "center", position: "absolute" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "auto",
                    left: "0px",
                    top: "85px",
                    transform: "translate(0%, -50%)",
                    position: "absolute",
                  }}
                >
                  <label style={{ fontSize: "24pt", fontWeight: "bolder" }}>Moving on the Mersey</label>
                  <label style={{ fontSize: "24pt", fontWeight: "400" }}>Visualising the Ecosystem</label>
                </div>
              </div>
            </div>
            <div className="App-main-background" onClick={this.closePopup}>
              <div className="App-main-icon-container" style={{ width: "80%" }}>
                {this.state.floatingLabels ? (
                  <div>
                    <img id="map" src={MerseySidePort} className="App-iso-map" alt="Aberdeen Port Isometric Map" style={{ height: "80%", width: "80vw" }}></img>
                    <div className="App-map-icon" style={{ top: "47.2%", left: "56.3%" }}>
                      <Popup
                        buttonName="Freight Vehicles"
                        withImage={true}
                        iconName={"ships"}
                        iconSize={"42.5"}
                        className="PopUp-pointer-tab-end PopUp-pointer-tab PopUp-square-button"
                        navigateCallback={() => this.scrollToDescription("Freight Vehicles", "Freight Description", "Freight Assessment")}
                      >
                        {/* {useCaseImageName = 'ship'} */}
                      </Popup>
                    </div>
                    <div className="App-map-icon" style={{ top: "59%", left: "62%" }}>
                      <Popup
                        buttonName="Redundant Berth Movement"
                        withImage={true}
                        iconName={"ship"}
                        iconSize={"5"}
                        className="PopUp-pointer-tab-end PopUp-pointer-tab PopUp-square-button"
                        navigateCallback={() =>
                          this.scrollToDescription("Redundant Berth Movements", "Redundant Berth Movements Description", "Redundant Berth Movements Assessment")
                        }
                      >
                        {/* {useCaseImageName = 'ship'} */}
                      </Popup>
                    </div>
                    <div className="App-map-icon" style={{ top: "75%", left: "50%" }}>
                      <Popup
                        buttonName="Crane"
                        withImage={false}
                        iconName={"freight"}
                        className="PopUp-arrow-tab-end PopUp-arrow-tab PopUp-square-button"
                        navigateCallback={() => this.scrollToDescription("Crane", "Crane Description", "Crane Assessment")}
                      ></Popup>
                    </div>
                  </div>
                ) : (
                  <div>
                    {!this.state.isMobile ? (
                      <div>
                        <div style={{ width: "100%", height: "50px" }} />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <div className="App-map-icon-container">
                            {/*onClick={(event) => {
                              this.setState({ x: event.nativeEvent.offsetX, y: event.nativeEvent.offsetY });
                            }}
                          >
                            <div style={{ width: "10px", height: "10px", backgroundColor: "black", position: "absolute", left: this.state.x, top: this.state.y, zIndex: 99 }}></div>
                            <p style={{ position: "absolute", zIndex: 99 }}>
                              {((this.state.x / 951) * 100).toFixed(3)}%:{((this.state.y / 535) * 100).toFixed(3)}%
                          </p>*/}
                            <img id="map" src={MerseySidePort} className="App-iso-map" alt="Aberdeen Port Isometric Map" style={{ display: "flex", width: "100%" }}></img>
                            <div style={{ width: "100%", height: "100%", position: "absolute", left: "0px", top: "0px" }}>
                              <img
                                id="route"
                                src={this.routes[this.state.buttonHighlightIndex].src}
                                alt={`Dotted line route for 's`}
                                style={{
                                  position: "absolute",
                                  left: this.routes[this.state.buttonHighlightIndex].xPosition,
                                  top: this.routes[this.state.buttonHighlightIndex].yPosition,
                                  width: this.routes[this.state.buttonHighlightIndex].size,
                                }}
                              ></img>
                            </div>
                            <div className="MapImages-popup" ref={this.popupRef}>
                              <MapPopup
                                title={this.state.mapPopupTitle}
                                description={this.state.mapPopupDescription}
                                src={this.state.mapPopupSrc}
                                bullets={this.state.mapPopupBullets}
                                popupRef={this.popupRef}
                                movePopup={this.movePopup}
                                openPopup={this.openPopup}
                                closePopup={this.closePopup}
                                animationTimer={this.state.animationTimer}
                              ></MapPopup>
                            </div>
                            <MapImages
                              data={this.state.selectedScope}
                              imageName={this.state.imageHighlightName}
                              mapPageCallback={(event) => this.handlePageChange(event)}
                              popupRef={this.popupRef}
                              closePopup={this.closePopup}
                              handleClick={this.handleMapClick}
                            />
                            <MapPins isMobile={this.state.isMobile} data={this.state.selectedPinData} handleClick={this.handleMapClick} />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              width: "20%",
                              height: "auto",
                              justifyContent: "center",
                              alignContent: "center",
                            }}
                          >
                            <MapButtons
                              swapPins={this.swapPins}
                              pinHighlightIndex={this.state.pinHighlightIndex}
                              highlightMapImage={(event) => this.swapImageHighlightName(event)}
                              unhighlightMapImage={(event) => this.swapImageUnhighlightName(event)}
                              mapPageCallback={(event) => this.handlePageChange(event)}
                              isMobile={this.state.isMobile}
                              closePopup={this.closePopup}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            width: "100%",
                            height: "100%",
                            left: "100%",
                            position: "relative",
                            justifyContent: "space-evenly",
                            alignContent: "space-evenly",
                            transform: "translate(-100%, 0%)",
                            zIndex: "1",
                          }}
                        >
                          <MapButtons
                            swapPins={this.swapPins}
                            pinHighlightIndex={this.state.pinHighlightIndex}
                            highlightMapImage={(event) => this.swapImageHighlightName(event)}
                            unhighlightMapImage={(event) => this.swapImageUnhighlightName(event)}
                            mapPageCallback={(event) => this.handlePageChange(event)}
                            isMobile={this.state.isMobile}
                            closePopup={this.closePopup}
                          />
                        </div>
                        <div className="App-map-icon-container">
                          <img id="map" src={MerseySidePort} className="App-iso-map" alt="Aberdeen Port Isometric Map" style={{ display: "flex", width: "100%" }}></img>
                          <div style={{ width: "100%", height: "100%", position: "absolute", left: "0px", top: "0px" }}>
                            <img
                              id="route"
                              src={this.routes[this.state.buttonHighlightIndex].src}
                              alt={`Dotted line route for 's`}
                              style={{
                                position: "absolute",
                                left: this.routes[this.state.buttonHighlightIndex].xPosition,
                                top: this.routes[this.state.buttonHighlightIndex].yPosition,
                                width: this.routes[this.state.buttonHighlightIndex].size,
                              }}
                            ></img>
                          </div>
                          <div className="MapImages-popup" ref={this.popupRef}>
                            <MapPopup
                              title={this.state.mapPopupTitle}
                              description={this.state.mapPopupDescription}
                              src={this.state.mapPopupSrc}
                              popupRef={this.popupRef}
                              movePopup={this.movePopup}
                              openPopup={this.openPopup}
                              closePopup={this.closePopup}
                              animationTimer={this.state.animationTimer}
                            ></MapPopup>
                          </div>
                          <MapImages
                            data={this.state.selectedScope}
                            imageName={this.state.imageHighlightName}
                            mapPageCallback={(event) => this.handlePageChange(event)}
                            popupRef={this.popupRef}
                            closePopup={this.closePopup}
                            handleClick={this.handleMapClick}
                          />
                          <MapPins isMobile={this.state.isMobile} data={this.state.selectedPinData} handleClick={this.handleMapClick} />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  width: "82.75%",
                  height: "auto",
                  justifyContent: "space-evenly" /* , border: '1.5px solid rgb(25, 26, 24)' */,
                }}
              >
                <ButtonGroup buttons={["Tourist", "Passenger", "Freight"]} activeScope={this.state.buttonHighlightIndex} changeDescriptorsOnClick={this.swapScopeFeatures} />
              </div>
            </div>

            <div className="Logo-space">
              <img alt="" src={require("./content/logos/Catapult.png").default}></img>
              <img alt="" src={require("./content/logos/Mersey_Maritime.png").default}></img>
              <img alt="" src={require("./content/logos/RHDHV.png").default}></img>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Map;
